import {
  BadgeCheck,
  Crown,
  Gem,
  Heart,
  Link2,
  Medal,
  ShieldCheck,
  Sparkles,
  Star,
  Ticket,
  Trophy,
  Zap,
} from "lucide-react";

const BADGE_ICONS = {
  BadgeCheck,
  Crown,
  Gem,
  Heart,
  Link2,
  Medal,
  ShieldCheck,
  Sparkles,
  Star,
  Ticket,
  Trophy,
  Zap,
  badge_check: BadgeCheck,
  crown: Crown,
  early_supporter: Star,
  founder: Crown,
  gem: Gem,
  heart: Heart,
  kick: Link2,
  linked_kick: Link2,
  linked_twitch: Link2,
  medal: Medal,
  shield: ShieldCheck,
  sparkles: Sparkles,
  star: Star,
  ticket: Ticket,
  trophy: Trophy,
  twitch: Link2,
  vip: Gem,
  zap: Zap,
};

export default function ProfileBadgeStrip({ badges, max = 3, size = "sm" }) {
  const rendered = (badges || [])
    .slice(0, max)
    .map((badge, index) => <ProfileBadge key={badge?.id || `${badge?.name || "badge"}-${index}`} badge={badge} size={size} />);
  if (rendered.length === 0) return null;
  return <span className="inline-flex items-center gap-1 shrink-0">{rendered}</span>;
}

function ProfileBadge({ badge, size }) {
  const title = badge?.name || badge?.title || humanizeBadgeId(badge?.id);
  if (!title) return null;
  const color = badge?.color || "#F6AE2D";
  const Icon = badgeIconFor(badge);
  const isLarge = size === "lg";
  return (
    <span
      title={title}
      aria-label={title}
      className={`inline-flex items-center justify-center rounded-[4px] border bg-black/65 shadow-[inset_0_1px_0_rgba(255,255,255,0.18),0_0_0_1px_rgba(0,0,0,0.45)] shrink-0 ${
        isLarge ? "h-6 w-6" : "h-5 w-5"
      }`}
      style={{
        borderColor: `${color}cc`,
        color,
        background: `linear-gradient(180deg, ${withAlpha(color, "30")} 0%, rgba(0,0,0,0.72) 72%)`,
      }}
    >
      <Icon className={isLarge ? "h-3.5 w-3.5" : "h-3 w-3"} strokeWidth={2.4} />
    </span>
  );
}

function badgeIconFor(badge) {
  const candidates = [
    badge?.icon,
    badge?.id,
    badge?.slug,
    badge?.name,
  ].map((value) => String(value || "").trim()).filter(Boolean);
  for (const candidate of candidates) {
    const direct = BADGE_ICONS[candidate] || BADGE_ICONS[candidate.toLowerCase().replace(/[\s-]+/g, "_")];
    if (direct) return direct;
  }
  return BadgeCheck;
}

function humanizeBadgeId(value) {
  return String(value || "").replace(/[_-]+/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function withAlpha(hex, alpha) {
  const raw = String(hex || "").trim();
  if (!/^#[0-9a-f]{6}$/i.test(raw)) return "rgba(246,174,45,0.18)";
  return `${raw}${alpha}`;
}
